module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@2x-c301e3d21ebdc4200e32f5f30f6f0919.png";